export var TITLE = 'Mistral';
export var TEXT_MULTIPLE = 0.75;
export var SPACE_MULTIPLE = 0.2;
export var COLOR_PRIMARY = '#fd6f00';
export var COLOR_GRADIENT = 'linear-gradient(to bottom, #F7D046, #F2A73B, #EE792F, #EE792F, #EA3326';